import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ModalArea, ToggleLinkArea } from './saveNewFilterModal.style';
import Button from '../../Button';
import Input from '../../Input';
import Box from '../../Box';
import Select from '../../Select';
import LoadingIndicator from '../../LoadingIndicator';
function SaveNewFilterModal(_ref) {
  let {
    savedFilters = [],
    isUpdate = true,
    currentFilter = '',
    isLoading = false,
    onClose,
    onSaveNewFilter
  } = _ref;
  const existingFilter = savedFilters.find(filter => filter.filter_title === currentFilter);
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [selectedExistingFilter, setSelectedExistingFilter] = useState((savedFilters === null || savedFilters === void 0 ? void 0 : savedFilters.length) ? existingFilter || savedFilters[0] : null);
  const [isFilterUpdate, setIsFilterUpdate] = useState(false);
  const [lengthError, setLengthError] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    setIsFilterUpdate(isUpdate);
  }, [isUpdate]);
  const onCloseModal = () => {
    onClose(false);
  };
  const saveColumnConfig = () => {
    if (isFilterUpdate) {
      if (selectedExistingFilter) {
        setIsSaving(true);
        onSaveNewFilter(selectedExistingFilter.value, isFilterUpdate);
        onCloseModal();
      }
    } else {
      if (selectedFilterName) {
        setIsSaving(true);
        onSaveNewFilter(selectedFilterName, isFilterUpdate);
        onCloseModal();
      }
    }
  };
  const handleIsUpdate = isUpdate => {
    setIsFilterUpdate(isUpdate);
    setLengthError(!isUpdate);
  };
  const onInput = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    const selectedFilterName = value.trim();
    if (value.trim().length >= 50) {
      setLengthError(true);
    } else {
      setLengthError(false);
    }
    setSelectedFilterName(selectedFilterName);
  };
  const onClear = () => {
    setSelectedFilterName('');
    setLengthError(true);
  };
  const handleFilterChange = _ref3 => {
    let {
      target: {
        value
      }
    } = _ref3;
    const findIndex = savedFilters.findIndex(item => item.value === value);
    setSelectedExistingFilter(savedFilters[findIndex]);
  };
  return _jsx(ModalArea, _extends({
    heading: "Save Filter",
    open: true,
    zindex: 999999,
    showCloseIcon: true,
    dimension: "medium",
    onClose: onCloseModal,
    actions: {
      primaryAction: _jsx(Button, {
        label: "Confirm",
        disabled: isLoading || isSaving || lengthError,
        loading: isSaving,
        onClick: saveColumnConfig
      }),
      secondaryAction: _jsx(Button, {
        variant: "outlined",
        label: "Cancel",
        onClick: onCloseModal
      })
    }
  }, {
    children: isFilterUpdate ? _jsx(Box, {
      children: isLoading ? _jsx(LoadingIndicator, {
        label: "Fetching applied filters...",
        variant: "bar"
      }) : _jsxs(Box, {
        children: [_jsx(Select, {
          id: "saved-filter",
          name: "savedFilter",
          label: "Modify saved filter",
          options: savedFilters,
          variant: "default",
          fit: "large",
          value: [selectedExistingFilter ? selectedExistingFilter.value : ''],
          placeholder: "Type",
          onChange: e => handleFilterChange(e)
        }), _jsx(ToggleLinkArea, {
          children: _jsx("button", _extends({
            onClick: () => handleIsUpdate(false)
          }, {
            children: "Create new filter"
          }))
        })]
      })
    }) : _jsxs(Box, {
      children: [_jsx(Input, {
        id: "saveFilter-search-input",
        label: "Filter name",
        placeholder: "Provide a name for the filter",
        clearButton: true,
        value: selectedFilterName,
        icon: "magnifying-glass",
        "icon-position": "left",
        onClear: onClear,
        onChange: e => onInput(e)
      }), savedFilters.length ? _jsx(ToggleLinkArea, {
        children: _jsx("button", _extends({
          onClick: () => handleIsUpdate(true)
        }, {
          children: "Update saved filter"
        }))
      }) : _jsx(_Fragment, {})]
    })
  }));
}
export default SaveNewFilterModal;